import { render, staticRenderFns } from "./create.vue?vue&type=template&id=d921c35c&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=d921c35c&prod&lang=css&scoped=true"
import style1 from "./create.vue?vue&type=style&index=1&id=d921c35c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d921c35c",
  null
  
)

export default component.exports